
// @ts-nocheck

import React, { useEffect, useState } from "react";
import SoftBox from "../../../components/common/softBox";
import SoftTypography from "../../../components/common/softTypography";
import SoftInput from "../../../components/common/softInput";
import SoftButton from "../../../components/common/softButton";
import { useDispatch, useSelector } from "react-redux";
import { editFaq, getFaqById } from "../../../features/faq";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";

const EditFaq = () => {
    const { id } = useParams<{ id: string }>();
  const { faq, status } = useSelector((state: any) => state.faq);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    id: id,
    question: "",
    answer: "",
    status: "Draft", // Default status
  });

  useEffect(() => {
         {/* @ts-ignore  */}

    dispatch(getFaqById(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (status && faq?.data) {
      const data = faq.data;
      setFormData({
        id: data._id,
        question: data.question,
        answer: data.answer,
        status: data.status || "Draft",
      });
    }
  }, [status, faq]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = () => {
         {/* @ts-ignore  */}
console.log(formData,'formData');

    dispatch(editFaq({ id, updatedFaq: formData }))
      .then((res: any) => {
        toast.success(res.payload.message);
        navigate('/faq')

      })
      .catch((err: any) => {
        console.error(err, "error");
      });
  };

  return (
        // @ts-ignore  

    <SoftBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      bgColor="white"
      shadow="lg"
      borderRadius="lg"
      p={4}
    >
      {/* Form Container */}
         {/* @ts-ignore  */}

      <SoftBox width="100%" maxWidth="400px">
         {/* @ts-ignore  */}

        <SoftBox mb={2}>
         {/* @ts-ignore  */}

          <SoftTypography variant="h4" fontWeight="bold" textAlign="center">
            Edit FAQ
          </SoftTypography>
        </SoftBox>
         {/* @ts-ignore  */}

        <SoftBox component="form" role="form">
          {/* Question Input */}
         {/* @ts-ignore  */}

          <SoftBox mb={2}>
         {/* @ts-ignore  */}

            <SoftBox mb={1} ml={0.5}>
         {/* @ts-ignore  */}

              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Question
              </SoftTypography>
            </SoftBox>
            <SoftInput
        //   @ts-ignore  

              type="text"
              name="question"
              placeholder="Enter the question"
              value={formData.question}
              onChange={handleChange}
            />
          </SoftBox>

          {/* Answer Input */}
         {/* @ts-ignore  */}

          <SoftBox mb={2}>
         {/* @ts-ignore  */}

            <SoftBox mb={1} ml={0.5}>
         {/* @ts-ignore  */}

              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Answer
              </SoftTypography>
            </SoftBox>
            <SoftInput
        //   @ts-ignore

              type="text"
              name="answer"
              placeholder="Enter the answer"
              value={formData.answer}
              onChange={handleChange}
            />
          </SoftBox>

          {/* Status Dropdown */}
         {/* @ts-ignore  */}

          <SoftBox mb={2}>
         {/* @ts-ignore  */}

            <SoftBox mb={1} ml={0.5}>
         {/* @ts-ignore  */}

              <SoftTypography component="label" variant="caption" fontWeight="bold">
                Status
              </SoftTypography>
            </SoftBox>
            <select
              name="status"
              value={formData.status}
              onChange={handleChange}
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc",
              }}
            >
              <option value="Draft">Draft</option>
              <option value="Published">Published</option>
            </select>
          </SoftBox>

          {/* Submit Button */}
         {/* @ts-ignore  */}

          <SoftBox mt={4} mb={1}>
         {/* @ts-ignore  */}

            <SoftButton variant="gradient" color="final" fullWidth onClick={handleSubmit}>
              Submit
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
};

export default EditFaq;
